import "./dashboardStats.css";

const numberSizeClass = (val) => {
  const len = String(val || "").replace(/[^0-9]/g, "").length;
  if (len >= 6) return " longNumber extraLongNumber";
  if (len >= 5) return " longNumber";
  return "";
};

const PotentialTradingAccount = ({ stats }) => {
  const value = Number(stats?.potentialTradingAccount) || 0;
  const yearlyPotential = value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return (
    <div className="potentialTradingCard">
      <h3 className="potentialTradingCard__title">
        Potential Trading Account Next Year
      </h3>
      <p
        className={`potentialTradingCard__amount${numberSizeClass(
          yearlyPotential
        )}`}
      >
        <span>$</span> {yearlyPotential}
      </p>
    </div>
  );
};

export default PotentialTradingAccount;
